import Cookies from "js-cookie";

/**
 * 删除cookie
 * @param target cookie 键
 * @param options cookie 配置
 * @returns
 */
export function removeToken(target: string, options = {}) {
  return Cookies.remove(target, options);
}
